import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import removeEmpty from '../../../utils/removeEmptyValuesFromObject';

const sendPOQuery = (data) => {
    const cleanedData = removeEmpty(data);
    return axios.post(apiurl?.saveSendPurchaseOrder, cleanedData);
};

const saveSendPurchaseOrder = () => {
    const queryClient = useQueryClient();
    return useMutation(['saveSendPurchaseOrder'], sendPOQuery, {
        onSuccess: () => {
            queryClient.invalidateQueries('getPOList');
        }
    });
};

export default saveSendPurchaseOrder;
